export default __webpack_public_path__ + "static/media/R5C_8166.c34b37c5.jpg";